<template>
    <div class="create">
        <el-dialog :title="editId == 0 ? '添加' : '编辑'" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <div class="main">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="right" class="demo-ruleForm" v-loading="formload">
                    <h3>经营商信息</h3>
                    <el-form-item label="经销商级别：" prop="level">
                        <el-select v-model="ruleForm.level" placeholder="请选择级别" @change="levelChange">
                            <el-option label="一级" value="1"></el-option>
                            <el-option label="二级" value="2"></el-option>
                            <el-option label="三级" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属上级：" prop="parent_id" v-if="ruleForm.level != 1">
                        <el-select v-model="ruleForm.parent_id" placeholder="请选择所属上级">
                            <el-option :label="v.name" :value="v.id" v-for="(v, i) in parentList" :key="i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="经销商名称：" prop="name">
                        <el-input v-model="ruleForm.name" clearable maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="经销商地址：" prop="address">
                        <el-input v-model="ruleForm.address" clearable></el-input>
                    </el-form-item>
                    <h3>负责人信息</h3>
                    <el-form-item label="负责人姓名：" prop="principals_name">
                        <el-input v-model="ruleForm.principals_name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="负责人电话：" prop="principals_phone">
                        <el-input v-model="ruleForm.principals_phone" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="负责人邮箱：" prop="principals_email">
                        <el-input v-model="ruleForm.principals_email" clearable></el-input>
                    </el-form-item>
                    <h3>授权信息</h3>
                    <el-form-item label="授权区域：" prop="area">
                        <el-cascader
                            style="width: 240px"
                            clearable
                            v-model="ruleForm.area"
                            collapse-tags
                            :options="city_list"
                            :props="{ multiple: true, expandTrigger: 'hover', label: 'ssqname', value: 'ssqid' }"
                            :show-all-levels="false"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="授权分类：" prop="authorize_ids">
                        <el-cascader
                            v-if="treeData && treeData.length > 0"
                            style="width: 240px"
                            clearable
                            v-model="ruleForm.authorize_ids"
                            collapse-tags
                            filterable
                            :options="treeData"
                            :props="{ multiple: true, expandTrigger: 'hover', label: 'name', value: 'id' }"
                            :show-all-levels="false"
                        ></el-cascader>
                        <el-link style="margin-left: 20px; line-height: 24px" v-else type="primary" @click="$router.push('/home/productManagement?type=class')">前往分类管理添加</el-link>
                    </el-form-item>
                    <el-form-item label="授权起止日期：" prop="date">
                        <el-date-picker
                            style="width: 100%"
                            v-model="ruleForm.date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="expireTimeOption"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="产品监控：" v-if="isHide('产品监控')" prop="prolist">
                        <el-button type="primary" size="small" @click="selPro('monitotr', 0)" v-if="editId == 0">{{
                            productIdList.length > 0 ? `已添加 ${productIdList.length} 个产品` : "点击添加"
                        }}</el-button>
                        <el-button v-else type="primary" size="small" @click="selPro('monitotr', editId)">{{ productCount > 0 ? `已添加 ${productCount} 个产品` : "点击添加" }}</el-button>
                    </el-form-item>
                    <el-form-item label="上传店铺信息：" v-if="isHide('上传店铺信息')" prop="wordlist">
                        <el-upload
                            :disabled="shopCount != 0"
                            class="btn upload-demo"
                            action=""
                            :on-change="(file, fileList) => handleChange(file, fileList, importShop)"
                            :show-file-list="true"
                            accept=".xls,.xlsx"
                            :auto-upload="false"
                            :limit="1"
                            :on-exceed="handleExceed"
                        >
                            <el-button slot="trigger" size="small" type="primary" :disabled="shopCount != 0">上传文件</el-button>
                            <div slot="tip" class="el-upload__tip">文件格式支持Excel</div>
                            <div class="down">
                                <el-link @click="downTmp">下载Excel模板</el-link>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="上传授权信息：" v-if="isHide('上传授权信息')" prop="imglist">
                        <el-upload
                            class="btn upload-demo"
                            action=""
                            :file-list="fileList"
                            :on-change="(file, fileList) => handleChange(file, fileList, uploadFile)"
                            :show-file-list="true"
                            :auto-upload="false"
                            :on-preview="(file) => handlePreview(file)"
                            :on-remove="(file, fileList) => handleRemove(file, fileList)"
                        >
                            <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                            <div slot="tip" class="el-upload__tip">文件格式支持图片、PDF</div>
                        </el-upload>
                    </el-form-item>
                    <!-- <el-form-item label="安装服务：" prop="servelist">
                        <el-button type="primary" size="small" @click="selPro('install')">点击添加</el-button>
                    </el-form-item>
                    <el-form-item label="售后服务：" prop="inlist">
                        <el-button type="primary" size="small" @click="selPro('serve')">点击添加</el-button>
                    </el-form-item> -->
                </el-form>
                <div class="contentManage" v-if="editId > 0">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="添加内容" name="first">
                            <div class="tag-group" v-if="tagList.length > 0">
                                <el-tag type="info" @click="addTag(index, item)" v-for="(item, index) in tagList" :key="index">+ {{ item.label }}</el-tag>
                            </div>
                            <p v-else style="text-align: center; padding-top: 10px">暂无标签！</p>
                        </el-tab-pane>
                        <el-tab-pane label="管理内容" name="second">
                            <div class="tag-group" v-if="delTagList.length > 0">
                                <el-tag type="info" closable @close="closeTag(index, item)" v-for="(item, index) in delTagList" :key="index">{{ item.label }}</el-tag>
                            </div>
                            <p v-else style="text-align: center; padding-top: 10px">暂无标签！</p>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="medium">取 消</el-button>
                <el-button @click="submit" type="primary" size="medium" :loading="load">确 认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="imgDialogVisible" width="500px">
            <img width="100%" :src="imgUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import address from "@/assets/address.js";
import config from "@/assets/config.json";
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            imgUrl: "",
            imgDialogVisible: false,
            fileList: [],
            activeName: "first",
            dialogVisible: false,
            load: false,
            formload: false,
            authorize: [],
            area: [],
            ruleForm: {
                level: "",
                parent_id: "",
                name: "",
                address: "",
                principals_name: "",
                principals_phone: "",
                principals_email: "",
                area: "",
                authorize_ids: "",
                date: [],
                prolist: [],
                wordlist: [],
                imglist: [],
                servelist: [],
                inlist: [],
            },
            rules: {
                level: [
                    {
                        required: true,
                        message: "请选择级别",
                        trigger: "change",
                    },
                ],
                parent_id: [
                    {
                        required: true,
                        message: "请选择所属上级",
                        trigger: "change",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入经销商名称",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入经销商地址",
                        trigger: "blur",
                    },
                ],
                principals_name: [
                    {
                        required: true,
                        message: "请输入负责人姓名",
                        trigger: "blur",
                    },
                ],
                principals_phone: [
                    {
                        required: true,
                        message: "请输入负责人电话",
                        trigger: "blur",
                    },
                    { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号" },
                ],
                principals_email: [
                    {
                        required: true,
                        message: "请输入负责人邮箱",
                        trigger: "blur",
                    },
                    {
                        pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
                        message: "请输入正确的邮箱地址",
                    },
                ],
                area: [
                    {
                        required: true,
                        message: "请选择授权区域",
                        trigger: "change",
                    },
                ],
                authorize_ids: [
                    {
                        required: true,
                        message: "请选择授权分类",
                        trigger: "change",
                    },
                ],
                date: [
                    {
                        required: true,
                        message: "请选择授权起止日期",
                        trigger: "change",
                    },
                ],
            },
            tagList: [
                { label: "产品监控", sort: 1 },
                { label: "上传店铺信息", sort: 2 },
                { label: "上传授权信息", sort: 3 },
                // { label: "安装服务", sort: 4 },
                // { label: "售后服务", sort: 5 },
            ],
            delTagList: [],
            parentList: [],
            city_list: [],
            address: address.province,
            productIdList: [],
            agencyShopId: [],
            authorize_image: [],
            editId: 0,
            productCount: 0,
            shopCount: 0,
            agency_authorization_id: 0,
        };
    },
    created() {
        this.initAddress();
    },
    props: {
        treeData: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        getAddress() {},
        ...mapActions({
            getParentList: "brand/getParentList",
            importShop: "brand/importShop",
            createAgency: "brand/createAgency",
            uploadFile: "commodity/uploadFile",
            agencyDetail: "brand/agencyDetail",
            editAgency: "brand/editAgency",
        }),
        getDetail(id) {
            this.editId = id;
            let arrOpt = JSON.parse(JSON.stringify(this.tagList));
            let opt = {
                token: this.getToken,
                id: id,
            };
            this.agencyDetail(opt).then(({ data }) => {
                if (data.code == 1) {
                    let {
                        name,
                        level,
                        parent_id,
                        address,
                        principals_name,
                        principals_phone,
                        principals_email,
                        area,
                        product_category_id,
                        start_time,
                        end_time,
                        agency_product_count,
                        agency_authorization_images,
                        agency_shop_count,
                        agency_authorization_id,
                    } = data.data;
                    (this.agency_authorization_id = agency_authorization_id), (this.shopCount = agency_shop_count);
                    if (agency_shop_count > 0) {
                        this.addTag(1, arrOpt[1]);
                    }
                    let addresslist = [];
                    area.forEach((item) => {
                        let arr = item.map((v) => {
                            return Number(v);
                        });
                        addresslist.push(arr);
                    });
                    let classlist = [];
                    product_category_id.forEach((item) => {
                        let arr = item.map((v) => {
                            return Number(v);
                        });
                        classlist.push(arr);
                    });
                    this.fileList = [];
                    if (agency_authorization_images && agency_authorization_images.length > 0) {
                        this.addTag(2, arrOpt[2]);
                        agency_authorization_images.forEach((item) => {
                            let obj = {
                                url: item,
                                name: item,
                            };
                            this.fileList.push(obj);
                        });
                    }
                    this.levelChange(level);
                    this.productCount = agency_product_count;
                    if (agency_product_count > 0) {
                        this.addTag(0, arrOpt[0]);
                    }
                    this.ruleForm = {
                        level: level,
                        parent_id: parent_id,
                        name: name,
                        address: address,
                        principals_name: principals_name,
                        principals_phone: principals_phone,
                        principals_email: principals_email,
                        area: addresslist,
                        authorize_ids: classlist,
                        date: [start_time, end_time],
                    };
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.load = true;
                    let { level, parent_id, name, address, principals_name, principals_phone, principals_email, area, authorize_ids, date } = this.ruleForm;
                    let opt = {
                        id: this.editId == 0 ? null : this.editId,
                        token: this.getToken,
                        port: "merchant", //必填项，固定值
                        name: name, //经销商名称
                        level: level, //经销商级别 1-一级 2-二级 3-三级
                        parent_id: parent_id ? parent_id : 0, //上级id
                        principals_name: principals_name, //负责人姓名
                        principals_phone: principals_phone, //负责人电话
                        principals_email: principals_email, //负责人邮箱
                        start_time: date ? date[0] : null, //授权开始时间
                        end_time: date ? date[1] : null, //授权结束时间
                        area: area, //授权区域，地区编号（逗号隔开）
                        address: address, //经销商地址
                        authorize_ids: authorize_ids, //授权分类，分类id的数组
                        product_ids: this.productIdList, //产品监控，产品id的数组
                        shop_ids: this.agencyShopId.length > 0 ? this.agencyShopId : null, //店铺信息，店铺id的数组
                        authorize_image: this.authorize_image, //授权信息图片地址,数组
                        agency_authorization_id: this.agency_authorization_id,
                    };
                    let url;
                    if (this.editId == 0) {
                        url = this.createAgency;
                    } else {
                        url = this.editAgency;
                        if (this.fileList && this.fileList.length > 0 && this.authorize_image.length == 0) {
                            let arr = [];
                            this.fileList.forEach((item) => {
                                arr.push(item.url);
                            });
                            opt.authorize_image = arr;
                        }
                    }
                    url(opt).then(({ data }) => {
                        this.load = false;
                        if (data.code == 1) {
                            this.$message.success(`${this.editId == 0 ? "添加成功！" : "修改成功！"}`);
                            this.$emit("init");
                            this.handleClose();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 上传店铺/授权信息
        handleChange(file, fileList, url) {
            this.disbtn = true;
            var formdata = new FormData();
            formdata.append("fileText", file.raw);
            formdata.append("token", this.getToken);
            if (url == this.importShop) {
                formdata.append("agencyId", this.editId);
                url(formdata).then(({ data }) => {
                    this.disbtn = false;
                    if (data.code == 1) {
                        this.$message.success("上传成功！");
                        this.agencyShopId = data.data.agencyShopId;
                    } else {
                        this.$message({
                            type: "error",
                            message: data.msg,
                        });
                    }
                });
            } else if (url == this.uploadFile) {
                url(formdata).then((res) => {
                    this.disbtn = false;
                    if (res.code == 1) {
                        this.$message.success("上传成功！");
                        this.authorize_image.push(res.data.fileText_details[0].urls);
                    } else {
                        this.$message({
                            type: "error",
                            message: data.msg,
                        });
                    }
                });
            }
        },
        // 下载店铺模板
        downTmp() {
            window.open(`${config.brandHttps.api}/file/template/agency-shop/%E5%BA%97%E9%93%BA%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx`);
        },
        //点击tag显示
        isHide(str) {
            return this.delTagList.some((item) => {
                return item.label == str;
            });
        },
        // 地区数据格式化
        initAddress() {
            this.address.forEach((item) => {
                item.children = item.cities.city;
                if (item.cities.city && item.cities.city.length > 0) {
                    item.cities.city.forEach((v) => {
                        v.children = v.areas.area;
                    });
                }
            });
            this.city_list = this.address;
        },
        // 经销商级别改变
        levelChange(val) {
            this.ruleForm.parent_id = "";
            if (val == 1) {
                return;
            }
            let opt = {
                token: this.getToken,
                port: "merchant", //必填项，固定值
                level: val, //经销商级别 1-一级 2-二级 3-三级
            };
            this.getParentList(opt).then(({ data }) => {
                if (data.code == 1) {
                    this.parentList = data.data;
                } else {
                    this.$message.error(data.msg);
                    this.parentList = [];
                }
            });
        },
        selPro(type, id) {
            this.$emit("selectProduct", type, id);
        },
        handleExceed(files, fileList) {
            this.$message.warning("最多只能上传一个文件！");
        },
        addTag(i, v) {
            this.tagList.splice(i, 1);
            this.delTagList.push(v);
            this.delTagList.sort(this.compare("sort"));
        },
        closeTag(i, v) {
            this.delTagList.splice(i, 1);
            this.tagList.push(v);
            this.tagList.sort(this.compare("sort"));
        },
        handleClose() {
            this.fileList = [];
            this.load = false;
            this.formload = false;
            this.editId = 0;
            this.ruleForm = {
                level: "",
                parent_id: "",
                name: "",
                address: "",
                principals_name: "",
                principals_phone: "",
                principals_email: "",
                area: "",
                authorize_ids: "",
                date: [],
            };
            this.tagList = [
                { label: "产品监控", sort: 1 },
                { label: "上传店铺信息", sort: 2 },
                { label: "上传授权信息", sort: 3 },
                // { label: "安装服务", sort: 4 },
                // { label: "售后服务", sort: 5 },
            ];
            this.agency_authorization_id = 0;
            this.shopCount = 0;
            this.delTagList = [];
            this.productIdList = [];
            this.authorize_image = [];
            this.agencyShopId = [];
            this.authorize = [];
            this.area = [];
            this.$emit("listIdNull");
            localStorage.setItem("clear", true);
            this.$refs.ruleForm.resetFields();
            this.dialogVisible = false;
        },
        // 数组按照某个属性排序
        compare(propertyName) {
            return function (object1, object2) {
                var value1 = object1[propertyName];
                var value2 = object2[propertyName];
                if (value2 > value1) {
                    return -1;
                } else if (value2 < value1) {
                    return 1;
                } else {
                    return 0;
                }
            };
        },
        isImage(val) {
            let ext = val.split(".").pop().toLowerCase();
            return ext == "jpg" || ext == "png" || ext == "jpeg";
        },
        handlePreview(file) {
            this.imgUrl = file.url;
            if (this.isImage(this.imgUrl)) {
                this.imgDialogVisible = true;
            } else {
                window.open(this.imgUrl);
            }
        },
        /*文件移除*/
        handleRemove(file, fileList) {
            this.fileList.map((v, i) => {
                if (v.name == file.name) {
                    this.fileList.splice(i, 1);
                }
            });
            this.authorize_image.map((v, i) => {
                if (v == file.url) {
                    this.authorize_image.splice(i, 1);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    .demo-ruleForm {
        max-height: 420px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
        h3 {
            margin-bottom: 20px;
            padding: 10px 0;
        }
        ::v-deep .el-form-item {
            width: 500px;
        }
    }
    .tag-group {
        padding-top: 10px;
        .el-tag {
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;
            height: 34px !important;
            line-height: 34px !important;
            font-size: 14px;
        }
    }
    .el-date-editor .el-range-separator {
        width: auto !important;
    }
    .upload-demo {
        position: relative;
        .down {
            position: absolute;
            right: 180px;
            top: 0;
            .el-link {
                font-size: 12px;
                line-height: 20px;
            }
        }
    }
}
</style>